<!--
  +---------------------------------------------------------------------------------------
  | @Author:    kangpengsen<kangpengsen@frippler.com>
  | @Title:     增值-商品管理-运费模板管理弹窗
  +---------------------------------------------------------------------------------------
-->
<template>
  <el-dialog
    class="shipping-template-dialog"
    title="运费模板管理"
    append-to-body
    :visible.sync="dialogShow"
    width="1200px"
  >
    <el-input v-model="query.keyword" class="search-input mb-md" placeholder="模板名称" prefix-icon="el-icon-search" clearable @change="searchInput" />
    <div v-loading="loading" class="template-list flex">
      <div class="template-item add-item border radius10 mr-lg mb-lg" @click="toDetail(0)">
        <div class="add-template flex column justify-content-center align-items-center">
          <i class="el-icon-plus"></i>
          <span class="text-center mt-md">新增运费模板</span>
        </div>
      </div>
      <div v-for="templateItem in filterList" class="template-item radius10 mr-lg mb-lg pt pb pl-md pr-md">
        <div class="template-item-title flex justify-content-space-between mb-md">
          <div v-overflow-tooltip="1" class="font-md ellipsis">{{ templateItem.name }}</div>
          <div class="operation font-lg">
            <i class="iconfont icon-edit mr" @click="toDetail(templateItem.templateid)"></i>
            <i class="iconfont icon-delete" @click="deleteTemplate(templateItem)"></i>
          </div>
        </div>
        <el-form label-position="left" label-width="100px">
          <el-form-item label="发货时效">
            <div class="text line-clamp-2">{{ $store.getters.deliveryTimeTypeObj[templateItem.delivery_time_type].value }}</div>
          </el-form-item>
          <el-form-item label="默认运费">
            <div class="text line-clamp-2">{{ templateItem.default_freight }}</div>
          </el-form-item>
          <el-form-item v-if="templateItem.calc_freight" label="指定运费">
            <div v-overflow-tooltip="2" class="text line-clamp-2">{{ templateItem.calc_freight }}</div>
          </el-form-item>
          <el-form-item label="不配送地区">
            <div v-overflow-tooltip="2" class="text line-clamp-2">{{ templateItem.no_send_area_freight }}</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { deleteShippingTemplateApi, getShippingTemplateListApi } from '@/api/ei/eiMallApi'
import searchInput from "@/views/datav/components/SearchInput.vue";
export default {
  name: "ShippingTemplateDialog",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      query: {
        keyword: ''
      },
      templateList: [],
      filterList: [],
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },
  methods: {
    fetchData() {
      this.loading = true;
      getShippingTemplateListApi(this.query).then(res => {
        if(res.errno === 0) {
          this.templateList = res.data.list
          this.filterList = res.data.list
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    searchInput() {
      this.loading = true;
      if(this.query.keyword === '') {
        this.filterList = this.templateList
      } else {
        const k = this.query.keyword.toLowerCase()
        this.filterList = this.templateList.filter(item => item.name.toLowerCase().includes(k))
      }
      this.loading = false
    },
    deleteTemplate(templateItem) {
      this.$confirm(`即将删除运费模板 <span class="text-danger">${ templateItem.name }</span>，是否继续？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在删除...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        deleteShippingTemplateApi({ templateid: templateItem.templateid }).then(res => {
          if(res.errno === 0) {
            this.fetchData()
            this.$message.success('删除成功!')
          } else {
            this.$message.error(res.message)
          }
          loading.close()
        })
      })
    },
    toDetail(templateid) {
      this.$router.push(`/em/shipping/template?templateid=` + templateid)
    }
  }
}
</script>

<style scoped lang="scss">
.shipping-template-dialog {
  /deep/ .el-dialog__body {
    padding-top: 10px;

    .search-input {
      width: 160px;
    }

    .template-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      min-height: 400px;
      .template-item {
        width: 360px;
        height: 250px;
        transition: all .1s;
        background-color: #EEF0F5;

        &.add-item {
          background-color: transparent;
        }

        .add-template {
          width: 100%;
          height: 100%;
          color: #909399;
          transition: all .1s;

          &:hover {
            cursor: pointer;
            color: #6c6f72;
          }

          i {
            font-size: 30px;
          }
        }

        .template-item-title {
          color: #303133;

          .operation {
            i {
              cursor: pointer;
              transition: all .1s;
              &:hover {
                color: #07c160;
              }
            }
          }
        }

        .el-form {
          .el-form-item {
            margin-bottom: 20px;
          }
          .text {
            color: #303133;
            vertical-align: top;
            line-height: 1.2;
          }
        }

      }
    }
  }

  /deep/ .el-form-item__label {
    line-height: 1.2;
  }
}
</style>
